import { useGetStreamsCount } from '@vlabs/api/artemy/client';
import { StreamStatusesParameterItem } from '@vlabs/api/artemy/model';

export interface GroupStreamsCounts {
  total: number;
  inProgress: number;
  isLoading: boolean;
}

// «Источников: N (В работе: M)» — «В работе» считаем только по статусу in_progress
export function useGroupStreamsCounts(groupId: string): GroupStreamsCounts {
  const total = useGetStreamsCount({ group_id: groupId });
  const inProgress = useGetStreamsCount({
    group_id: groupId,
    statuses: [StreamStatusesParameterItem.NUMBER_1],
  });

  return {
    total: total.data?.streams_count ?? 0,
    inProgress: inProgress.data?.streams_count ?? 0,
    isLoading: total.isLoading || inProgress.isLoading,
  };
}
